import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

function InfoIcon({
  Template,
  id = "",
  containerClass = "",
  placement = "right"
}) {
  return (
    <>
      <OverlayTrigger
        overlay={
          <Tooltip id={id} className={containerClass} placement={placement}>
            {Template || null}
          </Tooltip>
        }
      >
        <div className="template-info">i</div>
      </OverlayTrigger>
    </>
  );
}

export { InfoIcon };
